import React from 'react';
import { PieChart, Pie, Cell, Tooltip } from 'recharts';
import DashboardCard, { ChartBody, ChartEmpty, ChartPlot, ChartTooltip } from './DashboardCard';

interface LeadsByStatusChartProps {
    data: any[];
}

const LeadsByStatusChart: React.FC<LeadsByStatusChartProps> = ({ data }) => {
    return (
        <DashboardCard title="Status da negociação">
            {data.length === 0 ? (
                <ChartEmpty>Sem status neste período.</ChartEmpty>
            ) : (
                <ChartBody>
                    <ChartPlot>
                            <PieChart>
                                <Pie
                                    data={data}
                                    dataKey="value"
                                    nameKey="name"
                                    cx="50%"
                                    cy="50%"
                                    innerRadius="62%"
                                    outerRadius="88%"
                                    paddingAngle={4}
                                    stroke="none"
                                >
                                    {data.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={entry.color} />
                                    ))}
                                </Pie>
                                <Tooltip content={<ChartTooltip />} />
                            </PieChart>
                    </ChartPlot>
                    <ul className="flex flex-wrap justify-center gap-x-s3 gap-y-s1 pt-s3">
                        {data.map((item) => (
                            <li key={item.name} className="flex items-center gap-s1">
                                <span className="size-2 shrink-0 rounded-full" style={{ backgroundColor: item.color }} />
                                <span className="text-sm text-muted">{item.name}</span>
                            </li>
                        ))}
                    </ul>
                </ChartBody>
            )}
        </DashboardCard>
    );
};

export default LeadsByStatusChart;
